var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRolesDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 256,
    viewBox: "0 0 177 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2903_9654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 57.9686C17.5 44.7138 28.2452 33.9686 41.5 33.9686H135.5C148.755 33.9686 159.5 44.7138 159.5 57.9686V199.969C159.5 213.223 148.755 223.969 135.5 223.969H41.5C28.2452 223.969 17.5 213.223 17.5 199.969V57.9686Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 57.9686C18.5 45.2661 28.7975 34.9686 41.5 34.9686H135.5C148.203 34.9686 158.5 45.2661 158.5 57.9686V199.969C158.5 212.671 148.203 222.969 135.5 222.969H41.5C28.7975 222.969 18.5 212.671 18.5 199.969V57.9686Z",
    stroke: "black",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.764 162.843H30.684V151.355H34.764C38.412 151.355 40.62 153.691 40.62 157.035C40.62 160.379 38.332 162.843 34.764 162.843ZM33.116 153.451V160.747H34.636C36.924 160.747 38.124 159.419 38.124 157.035C38.124 154.747 36.924 153.451 34.636 153.451H33.116ZM47.205 162.843V161.787C46.645 162.587 45.797 163.003 44.629 163.003C42.853 163.003 41.669 161.963 41.669 160.363C41.669 158.699 43.013 157.803 45.509 157.803C45.989 157.803 46.405 157.835 46.933 157.899V157.387C46.933 156.427 46.389 155.867 45.461 155.867C44.501 155.867 43.925 156.427 43.845 157.387H41.845C41.973 155.419 43.397 154.139 45.461 154.139C47.701 154.139 49.013 155.371 49.013 157.467V162.843H47.205ZM43.765 160.299C43.765 161.019 44.277 161.467 45.109 161.467C46.245 161.467 46.933 160.843 46.933 159.851V159.243C46.405 159.163 46.037 159.131 45.653 159.131C44.389 159.131 43.765 159.531 43.765 160.299ZM56.1165 160.683V162.619C55.5725 162.891 55.0605 163.003 54.4045 163.003C52.6445 163.003 51.5405 161.995 51.5405 160.075V156.203H49.8125V154.299H51.5405V151.771H53.7485V154.299H56.1965V156.203H53.7485V159.563C53.7485 160.555 54.1965 160.955 54.9965 160.955C55.4125 160.955 55.7965 160.859 56.1165 160.683ZM62.6425 162.843V161.787C62.0825 162.587 61.2345 163.003 60.0665 163.003C58.2905 163.003 57.1065 161.963 57.1065 160.363C57.1065 158.699 58.4505 157.803 60.9465 157.803C61.4265 157.803 61.8425 157.835 62.3705 157.899V157.387C62.3705 156.427 61.8265 155.867 60.8985 155.867C59.9385 155.867 59.3625 156.427 59.2825 157.387H57.2825C57.4105 155.419 58.8345 154.139 60.8985 154.139C63.1385 154.139 64.4505 155.371 64.4505 157.467V162.843H62.6425ZM59.2025 160.299C59.2025 161.019 59.7145 161.467 60.5465 161.467C61.6825 161.467 62.3705 160.843 62.3705 159.851V159.243C61.8425 159.163 61.4745 159.131 61.0905 159.131C59.8265 159.131 59.2025 159.531 59.2025 160.299ZM38.412 178.731V180.843H30.684V169.355H38.3V171.467H33.116V173.883H37.82V175.979H33.116V178.731H38.412ZM42.3254 176.187V180.843H40.1014V172.299H42.1494V173.515C42.7734 172.667 43.6534 172.139 44.7734 172.139C46.4854 172.139 47.6694 173.259 47.6694 175.323V180.843H45.4614V176.075C45.4614 174.811 44.9654 174.107 43.9574 174.107C43.0774 174.107 42.3254 174.811 42.3254 176.187ZM53.2178 184.091C50.9138 184.091 49.3778 182.843 49.2818 180.875H51.4258C51.5218 181.851 52.1458 182.363 53.2018 182.363C54.4338 182.363 55.0738 181.707 55.0738 180.475V179.227C54.6098 180.043 53.7298 180.523 52.6898 180.523C50.5938 180.523 49.0258 178.747 49.0258 176.331C49.0258 173.851 50.4978 172.139 52.6098 172.139C53.7618 172.139 54.6258 172.587 55.2498 173.467V172.299H57.2818V180.443C57.2818 182.715 55.7458 184.091 53.2178 184.091ZM51.2498 176.331C51.2498 177.723 51.9698 178.603 53.1218 178.603C54.2898 178.603 55.0578 177.691 55.0578 176.347C55.0578 174.955 54.2898 174.059 53.1218 174.059C51.9858 174.059 51.2498 174.939 51.2498 176.331ZM61.8649 170.315C61.8649 171.067 61.2569 171.627 60.3769 171.627C59.5129 171.627 58.9049 171.067 58.9049 170.315C58.9049 169.531 59.5129 168.971 60.3769 168.971C61.2569 168.971 61.8649 169.531 61.8649 170.315ZM61.5129 180.843H59.2889V172.299H61.5129V180.843ZM65.716 176.187V180.843H63.492V172.299H65.54V173.515C66.164 172.667 67.044 172.139 68.164 172.139C69.876 172.139 71.06 173.259 71.06 175.323V180.843H68.852V176.075C68.852 174.811 68.356 174.107 67.348 174.107C66.468 174.107 65.716 174.811 65.716 176.187ZM76.6884 180.987C74.1284 180.987 72.4164 179.211 72.4164 176.539C72.4164 173.995 74.1924 172.139 76.6564 172.139C79.3604 172.139 81.1524 174.331 80.7524 177.115H74.6884C74.8324 178.507 75.5044 179.275 76.6404 179.275C77.6164 179.275 78.2724 178.795 78.5284 177.947H80.7364C80.2564 179.883 78.7684 180.987 76.6884 180.987ZM76.6084 173.771C75.5684 173.771 74.9124 174.443 74.7204 175.707H78.4004C78.3364 174.523 77.6644 173.771 76.6084 173.771ZM85.7977 180.987C83.2378 180.987 81.5258 179.211 81.5258 176.539C81.5258 173.995 83.3018 172.139 85.7658 172.139C88.4698 172.139 90.2618 174.331 89.8618 177.115H83.7978C83.9418 178.507 84.6138 179.275 85.7498 179.275C86.7258 179.275 87.3818 178.795 87.6378 177.947H89.8458C89.3658 179.883 87.8778 180.987 85.7977 180.987ZM85.7178 173.771C84.6778 173.771 84.0218 174.443 83.8298 175.707H87.5098C87.4458 174.523 86.7738 173.771 85.7178 173.771ZM93.5754 176.699V180.843H91.3514V172.299H93.3994V173.947C94.0234 172.859 95.3514 172.203 96.7274 172.203V174.507C94.8394 174.363 93.5754 174.811 93.5754 176.699ZM100.459 170.315C100.459 171.067 99.8506 171.627 98.9706 171.627C98.1066 171.627 97.4986 171.067 97.4986 170.315C97.4986 169.531 98.1066 168.971 98.9706 168.971C99.8506 168.971 100.459 169.531 100.459 170.315ZM100.107 180.843H97.8826V172.299H100.107V180.843ZM104.31 176.187V180.843H102.086V172.299H104.134V173.515C104.758 172.667 105.638 172.139 106.758 172.139C108.47 172.139 109.654 173.259 109.654 175.323V180.843H107.446V176.075C107.446 174.811 106.95 174.107 105.942 174.107C105.062 174.107 104.31 174.811 104.31 176.187ZM115.202 184.091C112.898 184.091 111.362 182.843 111.266 180.875H113.41C113.506 181.851 114.13 182.363 115.186 182.363C116.418 182.363 117.058 181.707 117.058 180.475V179.227C116.594 180.043 115.714 180.523 114.674 180.523C112.578 180.523 111.01 178.747 111.01 176.331C111.01 173.851 112.482 172.139 114.594 172.139C115.746 172.139 116.61 172.587 117.234 173.467V172.299H119.266V180.443C119.266 182.715 117.73 184.091 115.202 184.091ZM113.234 176.331C113.234 177.723 113.954 178.603 115.106 178.603C116.274 178.603 117.042 177.691 117.042 176.347C117.042 174.955 116.274 174.059 115.106 174.059C113.97 174.059 113.234 174.939 113.234 176.331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.349 120.816L36.6506 120.822C36.4811 123.669 36.0273 125.391 35.0042 126.429C33.9875 127.46 32.3264 127.894 29.4972 127.917L29.4924 128.617C32.2234 128.677 33.8592 129.064 34.8893 130.083C35.9247 131.108 36.4291 132.851 36.6509 135.869L37.3497 135.858C37.4701 132.976 37.9916 131.285 39.0581 130.257C40.1292 129.224 41.8271 128.781 44.5213 128.616L44.5156 127.917C41.8386 127.798 40.1922 127.376 39.1436 126.363C38.0947 125.35 37.5675 123.671 37.349 120.816Z",
    fill: "#FFEBAF",
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2257 77.747L71.2142 64.9906C71.9094 64.5873 72.767 64.5854 73.4639 64.9857L95.6023 77.7019C97.1047 78.5648 97.1089 80.7308 95.6099 81.5996L73.4681 94.4326C72.7691 94.8377 71.9066 94.837 71.2083 94.4307L49.2231 81.6379C47.7308 80.7696 47.7322 78.6134 49.2257 77.747Z",
    fill: "#434254",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4728 76.9973L71.206 64.2482C71.9059 63.8375 72.7728 63.8357 73.4745 64.2432L95.3558 76.9521C96.8457 77.8174 96.8499 79.9677 95.3634 80.8389L73.4787 93.6646C72.775 94.077 71.9031 94.0763 71.2001 93.6626L49.4703 80.8772C47.9905 80.0065 47.9919 77.866 49.4728 76.9973Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_2903_9654",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 64.2029H96.8654V79.403H47.9868V64.2029Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 64.2029H96.8654V79.403H47.9868V64.2029Z",
    fill: "#E4D6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4654 64.2029V79.403H97.2654V64.2029H96.4654ZM48.3868 79.403V64.2029H47.5868V79.403H48.3868Z",
    fill: "#434254",
    mask: "url(#path-7-inside-1_2903_9654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2257 62.2343L71.2142 49.4779C71.9094 49.0746 72.767 49.0727 73.4639 49.473L95.6023 62.1892C97.1047 63.0521 97.1089 65.2181 95.6099 66.0869L73.4681 78.9199C72.7691 79.325 71.9066 79.3243 71.2083 78.918L49.2231 66.1252C47.7308 65.2569 47.7322 63.1007 49.2257 62.2343Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2257 61.8279L71.2142 49.0714C71.9094 48.6681 72.767 48.6663 73.4639 49.0666L95.6023 61.7827C97.1047 62.6457 97.1089 64.8116 95.6099 65.6805L73.4681 78.5135C72.7691 78.9186 71.9066 78.9179 71.2083 78.5115L49.2231 65.7188C47.7308 64.8504 47.7322 62.6943 49.2257 61.8279Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7547 95.9719L47.038 85.8928C47.5893 85.5713 48.2705 85.5698 48.8231 85.8889L66.2242 95.9363C67.407 96.6192 67.4103 98.3252 66.2302 99.0127L48.8264 109.152C48.2722 109.475 47.587 109.475 47.0334 109.151L29.7527 99.043C28.5779 98.3559 28.579 96.6576 29.7547 95.9719Z",
    fill: "#434254",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7547 95.2023L47.038 85.1231C47.5893 84.8016 48.2705 84.8002 48.8231 85.1192L66.2242 95.1666C67.407 95.8495 67.4103 97.5556 66.2302 98.2431L48.8264 108.383C48.2722 108.706 47.587 108.705 47.0334 108.381L29.7527 98.2734C28.5779 97.5862 28.579 95.8879 29.7547 95.2023Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-2_2903_9654",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6685 84.4334H67.299V96.6937H28.6685V84.4334Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.6685 84.4334H67.299V96.6937H28.6685V84.4334Z",
    fill: "#E4D6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.899 84.4334V96.6937H67.699V84.4334H66.899ZM29.0685 96.6937V84.4334H28.2685V96.6937H29.0685Z",
    fill: "#434254",
    mask: "url(#path-13-inside-2_2903_9654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6479 82.5563L47.0262 72.4744C47.5757 72.1556 48.2535 72.1542 48.8043 72.4706L66.3011 82.5206C67.4885 83.2027 67.4918 84.9145 66.3071 85.6011L48.8076 95.7436C48.2552 96.0638 47.5735 96.0632 47.0216 95.742L29.6459 85.6314C28.4664 84.9452 28.4675 83.241 29.6479 82.5563Z",
    fill: "white",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-3_2903_9654",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 48.6902H96.8654V64.2029H47.9868V48.6902Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 48.6902H96.8654V64.2029H47.9868V48.6902Z",
    fill: "#E4D6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4654 48.6902V64.2029H97.2654V48.6902H96.4654ZM48.3868 64.2029V48.6902H47.5868V64.2029H48.3868Z",
    fill: "#434254",
    mask: "url(#path-16-inside-3_2903_9654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2257 46.8597L71.2142 34.1033C71.9094 33.7 72.767 33.6981 73.4639 34.0985L95.6023 46.8146C97.1047 47.6776 97.1089 49.8435 95.6099 50.7123L73.4681 63.5453C72.7691 63.9505 71.9066 63.9497 71.2083 63.5434L49.2231 50.7507C47.7308 49.8823 47.7322 47.7261 49.2257 46.8597Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2257 46.4534L71.2142 33.6969C71.9094 33.2936 72.767 33.2918 73.4639 33.6921L95.6023 46.4082C97.1047 47.2712 97.1089 49.4371 95.6099 50.3059L73.4681 63.139C72.7691 63.5441 71.9066 63.5434 71.2083 63.137L49.2231 50.3443C47.7308 49.4759 47.7322 47.3198 49.2257 46.4534Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-4_2903_9654",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 33.3157H96.8654V48.8284H47.9868V33.3157Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 33.3157H96.8654V48.8284H47.9868V33.3157Z",
    fill: "#E4D6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4654 33.3157V48.8284H97.2654V33.3157H96.4654ZM48.3868 48.8284V33.3157H47.5868V48.8284H48.3868Z",
    fill: "#434254",
    mask: "url(#path-20-inside-4_2903_9654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2257 30.8525L71.2142 18.0961C71.9094 17.6928 72.767 17.6909 73.4639 18.0913L95.6023 30.8074C97.1047 31.6704 97.1089 33.8363 95.6099 34.7051L73.4681 47.5381C72.7691 47.9433 71.9066 47.9425 71.2083 47.5362L49.2231 34.7435C47.7308 33.8751 47.7322 31.7189 49.2257 30.8525Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2257 30.5273L71.2142 17.7709C71.9094 17.3676 72.767 17.3657 73.4639 17.7661L95.6023 30.4822C97.1047 31.3452 97.1089 33.5111 95.6099 34.3799L73.4681 47.2129C72.7691 47.6181 71.9066 47.6173 71.2083 47.211L49.2231 34.4183C47.7308 33.5499 47.7322 31.3937 49.2257 30.5273Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-5_2903_9654",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 17.803H96.8654V33.3157H47.9868V17.803Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.9868 17.803H96.8654V33.3157H47.9868V17.803Z",
    fill: "#E4D6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4654 17.803V33.3157H97.2654V17.803H96.4654ZM48.3868 33.3157V17.803H47.5868V33.3157H48.3868Z",
    fill: "#434254",
    mask: "url(#path-24-inside-5_2903_9654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4365 29.0984C51.4365 29.6465 51.823 30.3143 52.3002 30.5901C52.7775 30.8659 53.1639 30.6452 53.1639 30.0971C53.1639 29.549 52.7775 28.8812 52.3002 28.6053C51.823 28.3295 51.4365 28.5503 51.4365 29.0984Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4365 45.4108C51.4365 45.9589 51.823 46.6268 52.3002 46.9026C52.7775 47.1784 53.1639 46.9576 53.1639 46.4095C53.1639 45.8614 52.7775 45.1936 52.3002 44.9178C51.823 44.642 51.4365 44.8627 51.4365 45.4108Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4365 61.7232C51.4365 62.2713 51.823 62.9391 52.3002 63.2149C52.7775 63.4907 53.1639 63.27 53.1639 62.7219C53.1639 62.1738 52.7775 61.506 52.3002 61.2302C51.823 60.9544 51.4365 61.1751 51.4365 61.7232Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0898 92.3677C31.0898 92.9158 31.4763 93.5837 31.9536 93.8595C32.4308 94.1353 32.8173 93.9145 32.8173 93.3664C32.8173 92.8183 32.4308 92.1505 31.9536 91.8747C31.4763 91.5989 31.0898 91.8196 31.0898 92.3677Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9302 31.3815C54.9302 31.9296 55.3166 32.5975 55.7939 32.8733C56.2711 33.1491 56.6576 32.9283 56.6576 32.3802C56.6576 31.8321 56.2711 31.1643 55.7939 30.8885C55.3166 30.6127 54.9302 30.8334 54.9302 31.3815Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9302 47.6939C54.9302 48.242 55.3166 48.9098 55.7939 49.1856C56.2711 49.4614 56.6576 49.2407 56.6576 48.6926C56.6576 48.1445 56.2711 47.4767 55.7939 47.2009C55.3166 46.9251 54.9302 47.1458 54.9302 47.6939Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9302 64.0063C54.9302 64.5544 55.3166 65.2223 55.7939 65.4981C56.2711 65.7739 56.6576 65.5531 56.6576 65.005C56.6576 64.457 56.2711 63.7891 55.7939 63.5133C55.3166 63.2375 54.9302 63.4583 54.9302 64.0063Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.584 94.6509C34.584 95.199 34.9705 95.8668 35.4477 96.1426C35.9249 96.4184 36.3114 96.1977 36.3114 95.6496C36.3114 95.1015 35.9249 94.4336 35.4477 94.1578C34.9705 93.882 34.584 94.1028 34.584 94.6509Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2257 16.5099L71.2142 3.75345C71.9094 3.35013 72.767 3.34828 73.4639 3.74861L95.6023 16.4647C97.1047 17.3277 97.1089 19.4937 95.6099 20.3625L73.4681 33.1955C72.7691 33.6006 71.9066 33.5999 71.2083 33.1935L49.2231 20.4008C47.7308 19.5324 47.7322 17.3763 49.2257 16.5099Z",
    fill: "#E4D6FD",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2257 15.9725L71.2142 3.2161C71.9094 2.81278 72.767 2.81093 73.4639 3.21125L95.6023 15.9274C97.1047 16.7904 97.1089 18.9563 95.6099 19.8251L73.4681 32.6581C72.7691 33.0633 71.9066 33.0625 71.2083 32.6562L49.2231 19.8634C47.7308 18.9951 47.7322 16.8389 49.2257 15.9725Z",
    fill: "#434254",
    stroke: "#434254",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 36.5379V34.6915L79.9857 31.8809V33.7478L75.0415 36.5379Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 52.2303V50.3839L79.9857 47.5733V49.4402L75.0415 52.2303Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 67.9228V66.0764L79.9857 63.2657V65.1327L75.0415 67.9228Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0415 83.6152V81.7687L79.9857 78.9581V80.825L75.0415 83.6152Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5542 99.5969V97.7504L55.4984 94.9398V96.8067L50.5542 99.5969Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1963 33.121V31.2746L86.1405 28.464V30.3309L81.1963 33.121Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1963 48.8134V46.967L86.1405 44.1564V46.0233L81.1963 48.8134Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1963 64.5058V62.6594L86.1405 59.8488V61.7157L81.1963 64.5058Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1963 80.1982V78.3518L86.1405 75.5412V77.4081L81.1963 80.1982Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.709 96.18V94.3336L61.6532 91.5229V93.3899L56.709 96.18Z",
    fill: "#434254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3536 38.336L60.7031 40.4693C59.3224 41.2762 58.4736 42.7553 58.4736 44.3545V79.3756",
    stroke: "#434254",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0435 35.0372L55.3931 37.1706C54.0123 37.9775 53.1636 39.4565 53.1636 41.0558L53.1636 76.3052",
    stroke: "#434254",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2903_9654",
    x: 0.5,
    y: 0.71228,
    width: 176,
    height: 255.256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.159362 0 0 0 0 0.445833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_9654"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_9654",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesDe);
export default __webpack_public_path__ + "static/media/roles-de.20e5a181d5155d2bde8551cb11d77059.svg";
export { ForwardRef as ReactComponent };